
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 3000 3000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-venus",attrs:{"stroke":"#D0EFEC","stroke-width":"4","d":"M1620.44 1377.72a171.8 171.8 0 0 1 40.6 62.91 171.7 171.7 0 0 1 9.95 74.22c-2.19 25.17-9.9 49.54-22.6 71.38a171.6 171.6 0 0 1-50.83 54.98"}}),_c('path',{staticClass:"i-mercury",attrs:{"stroke":"#fff","stroke-dasharray":"15 20","stroke-miterlimit":"10","stroke-width":"2.5","d":"M1500 1572.79c40.23 0 72.84-32.59 72.84-72.79s-32.61-72.79-72.84-72.79-72.84 32.59-72.84 72.79 32.61 72.79 72.84 72.79Z"}}),_c('path',{staticClass:"i-sun",attrs:{"fill":"#F9CE62","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"10","d":"M1500 1547.12c26.02 0 47.12-21.1 47.12-47.12 0-26.03-21.1-47.12-47.12-47.12-26.03 0-47.12 21.09-47.12 47.12 0 26.02 21.09 47.12 47.12 47.12Z"}}),_c('path',{staticClass:"i-earth counterclockwise slow",attrs:{"stroke":"#73D6D3","stroke-dasharray":"5 10","d":"M283.845 1542.87a1217 1217 0 0 1 16.522-247.2"}}),_c('path',{staticClass:"i-venus clockwise",attrs:{"stroke":"#F1FCFC","stroke-width":"55","d":"M658.01 2317.98c-141.297-153.1-240.435-342.03-287.188-547.46"}})])
          )
        }
      }
    